
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Forceurbaniaseventineseater() {



    const cardData =
    {
        keyword: 'Force Urbania 17 Seater On Rent in Pune ',
        heading: 'Amruta Travels: Force Urbania 17 Seater On Rent in Pune ',
        headingDescription: 'Amruta Travels offers Force Urbania 17 Seater on Rent in Pune, providing a premium, spacious, and comfortable travel solution for group transportation. Ideal for corporate tours, weddings, outstation trips, school excursions, family outings, and special events, our Force Urbania 17-seater ensures a smooth and luxurious journey. Equipped with modern interiors, push-back seats, ample legroom, and air-conditioning, this vehicle is perfect for hassle-free group travel. With experienced drivers, punctual service, competitive rental rates, and 24/7 customer support, Amruta Travels makes your journey safe, comfortable, and stress-free. Book your Force Urbania 17 Seater on Rent in Pune with Amruta Travels and travel together in comfort and style.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



 "services": [
  {
    "name": "17 seater Force Urbania on rent near me Pune",
    "description": "17 seater Force Urbania on rent near you in Pune with premium interiors, push-back seating, powerful air conditioning, large windows, and ample luggage space. Ideal for family tours, corporate travel, weddings, airport transfers, and comfortable outstation journeys with experienced drivers."
  },
  {
    "name": "Best 17 seater Urbania rental service Pune",
    "description": "Best 17 seater Urbania rental service in Pune offering luxury travel experience, well-maintained vehicles, courteous drivers, on-time service, and competitive pricing for local trips, airport transfers, corporate events, and long-distance travel."
  },
  {
    "name": "Force Urbania 17 seater rent in Pimpri Chinchwad",
    "description": "Force Urbania 17 seater available on rent in Pimpri Chinchwad Pune with clean interiors, smooth suspension, comfortable seating, and professional drivers suitable for group outings, office travel, family functions, and outstation tours."
  },
  {
    "name": "Force Urbania 17 seater rent in Kharadi Pune",
    "description": "Luxury Force Urbania 17 seater on rent in Kharadi Pune for corporate employees, IT companies, airport transfers, business meetings, and weekend trips with safety, comfort, and punctual service assured."
  },
  {
    "name": "17 seater Urbania Pune Wagholi Rent",
    "description": "17 seater Urbania bus rental service in Wagholi Pune providing spacious seating, air-conditioned comfort, smooth rides, and reliable service for local travel, airport drops, family tours, and outstation journeys."
  },
  {
    "name": "Force Urbania 17 seater on rent Swargate Pune",
    "description": "Force Urbania 17 seater on rent in Swargate Pune ideal for group departures, tour packages, pilgrimage travel, and long-distance journeys with luxury comfort and experienced route-friendly drivers."
  },
  {
    "name": "Urbania 17 seater hire Baner Pune",
    "description": "Urbania 17 seater hire service in Baner Pune suitable for corporate travel, business meetings, airport transfers, conferences, and premium group transportation with professional support."
  },
  {
    "name": "Force Urbania 17 seater rent Hadapsar Pune",
    "description": "17 seater Force Urbania rental service in Hadapsar Pune offering modern interiors, AC comfort, ample legroom, and reliable drivers for weddings, family trips, corporate events, and outstation travel."
  },
  {
    "name": "17 seater Urbania van Pune airport transfer",
    "description": "17 seater Urbania van for Pune airport pickup and drop with punctual service, spacious luggage capacity, air-conditioned comfort, and professional drivers ensuring stress-free airport travel."
  },
  {
    "name": "Force Urbania 17 seater Pune railway station pickup",
    "description": "Force Urbania 17 seater pickup service at Pune railway station designed for families, corporate groups, tourists, and wedding guests with smooth coordination and comfortable seating."
  },
  {
    "name": "Force Urbania 17 seater for Pune to Lonavala trip",
    "description": "Pune to Lonavala trip in 17 seater Force Urbania offering scenic travel, smooth hill driving performance, comfortable seating, and relaxed group travel experience."
  },
  {
    "name": "17 seater Urbania for family trip from Pune",
    "description": "17 seater Urbania ideal for family trips from Pune providing safety, comfort, ample space, and relaxed travel for weekend getaways, holidays, and long-distance tours."
  },
  {
    "name": "Luxury 17 seater Force Urbania on rent Pune",
    "description": "Luxury 17 seater Force Urbania available on rent in Pune with premium design, push-back seats, climate control, smooth ride quality, and professional chauffeur-driven service."
  },
  {
    "name": "Force Urbania 17 seater Pune corporate travel rental",
    "description": "17 seater Force Urbania for corporate travel in Pune suitable for employee transport, client visits, conferences, offsite meetings, and executive group movement."
  },
  {
    "name": "Affordable 17 seater Force Urbania rent Pune",
    "description": "Affordable 17 seater Force Urbania rental in Pune offering best value pricing without compromising on vehicle quality, comfort, safety, or service standards."
  },
  {
    "name": "Force Urbania 17 seater Pune weekend hire",
    "description": "Weekend hire service for Force Urbania 17 seater in Pune perfect for short trips, family outings, holiday plans, and quick getaways with flexible rental options."
  },
  {
    "name": "Force Urbania 17 seater Pune tour packages",
    "description": "Pune tour packages available with 17 seater Force Urbania including customized itineraries, experienced drivers, comfortable travel, and reliable service for group tours."
  },
  {
    "name": "Pune to Mahabaleshwar 17 seater Urbania on rent",
    "description": "17 seater Urbania on rent from Pune to Mahabaleshwar ideal for hill station travel with comfortable seating, AC, and smooth long-distance driving."
  },
  {
    "name": "Pune to Shirdi Urbania on rent",
    "description": "Urbania bus rental service from Pune to Shirdi offering peaceful and comfortable pilgrimage travel with experienced drivers familiar with temple routes."
  },
  {
    "name": "Pune to Goa Urbania on rent",
    "description": "17 seater Urbania on rent from Pune to Goa for long-distance coastal travel with luxury comfort, ample space, and relaxed group journey."
  },
  {
    "name": "Pune to Mumbai Urbania on rent",
    "description": "Urbania bus rental service from Pune to Mumbai suitable for airport transfers, corporate travel, family visits, and intercity group transportation."
  },
  {
    "name": "Pune to Konkan Darshan Urbania on rent",
    "description": "Konkan Darshan tour from Pune with 17 seater Urbania offering comfortable long-route travel, scenic journeys, and reliable tour support."
  },
  {
    "name": "Pune to Bhimashankar Urbania on rent",
    "description": "17 seater Urbania rental service from Pune to Bhimashankar for group pilgrimages with safe driving, hill-route expertise, and comfort."
  },
  {
    "name": "Pune to 3 Jyotirlinga Urbania on rent",
    "description": "3 Jyotirlinga spiritual tour from Pune with 17 seater Urbania providing comfortable seating, long-distance travel support, and reliable service."
  },
  {
    "name": "Pune to Kolhapur Urbania on rent",
    "description": "Urbania bus rental service from Pune to Kolhapur ideal for family travel, temple visits, and long-distance group journeys."
  },
  {
    "name": "Pune to Aurangabad Urbania on rent",
    "description": "17 seater Urbania on rent from Pune to Aurangabad suitable for heritage tours, family travel, and comfortable long-route journeys."
  },
  {
    "name": "Pune to Nashik Urbania on rent",
    "description": "Urbania rental service from Pune to Nashik perfect for vineyard visits, temple tours, family trips, and group travel."
  },
  {
    "name": "Pune to Trimbakeshwar Urbania on rent",
    "description": "17 seater Urbania rental service from Pune to Trimbakeshwar for comfortable and well-managed pilgrimage group travel."
  }
],
"tableData": [
  ["17 seater Force Urbania on rent near me Pune", "Best 17 seater Urbania rental service Pune"],
  ["Force Urbania 17 seater rent in Pimpri Chinchwad", "Force Urbania 17 seater rent in Kharadi Pune"],
  ["17 seater Urbania Pune Wagholi Rent", "Force Urbania 17 seater on rent Swargate Pune"],
  ["Urbania 17 seater hire Baner Pune", "Force Urbania 17 seater rent Hadapsar Pune"],
  ["17 seater Urbania van Pune airport transfer", "Force Urbania 17 seater Pune railway station pickup"],
  ["Force Urbania 17 seater for Pune to Lonavala trip", "17 seater Urbania for family trip from Pune"],
  ["Luxury 17 seater Force Urbania on rent Pune", "Force Urbania 17 seater Pune corporate travel rental"],
  ["Affordable 17 seater Force Urbania rent Pune", "Force Urbania 17 seater Pune weekend hire"],
  ["Force Urbania 17 seater Pune tour packages", "Pune to Mahabaleshwar 17 seater Urbania on rent"],
  ["Pune to Shirdi Urbania on rent", "Pune to Goa Urbania on rent"],
  ["Pune to Mumbai Urbania on rent", "Pune to Konkan Darshan Urbania on rent"],
  ["Pune to Bhimashankar Urbania on rent", "Pune to 3 Jyotirlinga Urbania on rent"],
  ["Pune to Kolhapur Urbania on rent", "Pune to Aurangabad Urbania on rent"],
  ["Pune to Nashik Urbania on rent", "Pune to Trimbakeshwar Urbania on rent"]
],


"whychoose": [
  {
    "WhyChooseheading": "Premium 17 Seater Luxury Travel Solution",
    "WhyChoosedescription": "Amruta Travels offers Force Urbania 17 Seater On Rent in Pune, providing a perfect blend of luxury, comfort, and space. Ideal for medium-sized groups, this premium vehicle ensures a smooth and stylish travel experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Family, and Event Travel",
    "WhyChoosedescription": "Whether it’s a corporate tour, family trip, wedding guest transport, or VIP movement, the Force Urbania 17 Seater delivers unmatched comfort and elegance for every type of journey."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "Designed with plush seating, ample legroom, powerful air conditioning, wide windows, and generous luggage space, the Force Urbania 17 Seater ensures a relaxed and enjoyable ride even on long journeys."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our skilled and courteous drivers are well-trained to operate the Force Urbania, ensuring safe, punctual, and comfortable travel throughout Pune and outstation routes."
  },
  {
    "WhyChooseheading": "Affordable Pricing with Complete Transparency",
    "WhyChoosedescription": "Enjoy luxury travel at competitive rates with Amruta Travels. We offer transparent pricing with no hidden charges, giving you excellent value for your 17 seater rental needs."
  },
  {
    "WhyChooseheading": "Well-Maintained and Hygienic Vehicles",
    "WhyChoosedescription": "Our Force Urbania 17 Seater buses are regularly serviced and thoroughly cleaned before every trip, ensuring high standards of hygiene, safety, and comfort."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Route Planning",
    "WhyChoosedescription": "We provide flexible pickup and drop-off locations along with customized travel routes to match your schedule, whether it’s within Pune or for outstation travel."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking a Force Urbania 17 Seater On Rent in Pune is quick and hassle-free with Amruta Travels. Our dedicated support team assists you from booking to journey completion."
  }
]

    }

const faqData = [
  {
    question: 'How can I book a Force Urbania 17 Seater on rent in Pune with Amruta Travels?',
    answer: 'Booking a Force Urbania 17 Seater in Pune with Amruta Travels is simple. You can book online, call our customer support, or visit our office, and our team will assist you with the best rental option.'
  },
  {
    question: 'What are the features of the Force Urbania 17 Seater?',
    answer: 'The Force Urbania 17 Seater features luxurious interiors, comfortable pushback seats, air conditioning, large windows, modern amenities, and ample luggage space for a premium travel experience.'
  },
  {
    question: 'Is the Force Urbania 17 Seater suitable for outstation trips?',
    answer: 'Yes, the Force Urbania 17 Seater is ideal for both local and outstation travel. It offers excellent comfort and stability for long-distance journeys.'
  },
  {
    question: 'Does the rental include a driver?',
    answer: 'Yes, every Force Urbania 17 Seater rental from Amruta Travels includes a professional and experienced driver for a safe and smooth journey.'
  },
  {
    question: 'Are the Force Urbania 17 Seaters well-maintained?',
    answer: 'Absolutely. All our Force Urbania 17 Seater vehicles are regularly serviced, sanitized, and maintained to ensure maximum safety, cleanliness, and comfort.'
  },
  {
    question: 'What is the rental cost for a Force Urbania 17 Seater in Pune?',
    answer: 'The rental cost depends on trip duration, distance, and specific travel requirements. Contact Amruta Travels for a customized and transparent quote.'
  },
  {
    question: 'Can I customize pickup and drop-off locations?',
    answer: 'Yes, we offer flexible pickup and drop-off options as per your travel plan. Just share your schedule and preferred locations with us.'
  },
  {
    question: 'Why choose Amruta Travels for Force Urbania 17 Seater rental in Pune?',
    answer: 'Amruta Travels provides premium Force Urbania 17 Seater rentals with well-maintained vehicles, professional drivers, transparent pricing, and exceptional customer support.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rahul Kulkarni',
    role: 'IT Project Manager, Pune',
    text: 'We rented a Force Urbania 17 Seater for a corporate offsite. The vehicle was extremely comfortable and clean. The driver was professional and punctual. Excellent service by Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Anjali Deshmukh',
    role: 'Wedding Planner, Pune',
    text: 'Booked a Force Urbania 17 Seater for wedding guest transportation. The bus was luxurious and very spacious. Our guests loved the comfort. Highly recommended Amruta Travels!',
    rating: 5
  }
];











































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania 17 Seater On Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/force-urbania-17-seater-on-rent-pune.jpg",
  "description": "Hire a luxury Force Urbania 17 seater on rent in Pune with Amruta Travels. Ideal for family trips, corporate travel, airport transfers, railway station pickups, weekend getaways, and outstation tours. Available across Pimpri Chinchwad, Kharadi, Wagholi, Baner, Hadapsar, Swargate, and Pune Airport. Affordable and comfortable Urbania rental service for trips to Lonavala, Mahabaleshwar, Shirdi, Goa, Mumbai, Konkan Darshan, Bhimashankar, Trimbakeshwar, Nashik, Kolhapur, Aurangabad, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2980"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/force-urbania-17-seater-on-rent-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Force Urbania 17 Seater On Rent in Pune | Amruta Travels</title>
  <meta
    name="description"
    content="Book Force Urbania 17 seater on rent in Pune with Amruta Travels. Luxury Urbania rental for family trips, corporate travel, airport transfers, and outstation tours to Lonavala, Mahabaleshwar, Shirdi, Goa, Mumbai, Nashik, Trimbakeshwar & more at affordable rates."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/96.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Forceurbaniaseventineseater;